<template>

    <!-- Create account -->
    <div id="formFolio" class="w-full md:w-2/5 mt-4 mx-auto px-4 md:px-0 md:min-w-124">
        <div class="title uppercase text-center font-bold">
            {{ $t("Forms.i_want_new_user") }}
        </div>
        <p class="text-sm mt-3 mb-3 px-8 w-full relative text-justify">
            {{ $t("Forms.i_want_new_user_description") }}
        </p>
        <p class="mb-4 text-sm mt-3 px-8 w-full relative text-justify">
            {{ $t("Forms.if_you_have_account") }}
            <a class="cursor-pointer text-newxcaret-blue" @click.prevent="setModalAuth(1)">
                {{ $t("Forms.login") }}
            </a>
        </p>

        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(register)" class="px-8 pt-2 pb-6 w-full relative">
                <div class="flex -mx-2">
                    <div class="w-1/2 mx-2 mb-2">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <!-- Nombre -->
                            <label class="font-bold" :for="$t('Forms.firstname')">{{ $t("Forms.firstname")
                                }}</label>
                            <input type="text" v-model="formRegister.FirstName" :placeholder="$t('Forms.firstname')"
                                :name="$t('Forms.firstname')" :class="[errors.length && 'border-newxcaret-red']"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey" />
                            <p class="txt-error text-red text-xs italic">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>

                    <div class="w-1/2 mx-2 mb-2">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <!-- Apellidos -->
                            <label class="font-bold" :for="$t('Forms.lastname')">{{ $t("Forms.lastname")
                                }}</label>
                            <input type="text" v-model="formRegister.LastName" :placeholder="$t('Forms.lastname')"
                                :name="$t('Forms.lastname')" :class="[errors.length && 'border-newxcaret-red']"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey" />
                            <p class="txt-error text-red text-xs italic">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>
                </div>

                <div class="w-full mb-2 relative">
                    <ValidationProvider rules="required|email" v-slot="{ errors }">
                        <!-- Correo Electronico -->
                        <label class="font-bold" :for="$t('Forms.email')">{{ $t("Forms.email") }}</label>
                        <input type="email" v-model="formRegister.Email"
                            :class="[errors.length && 'border-newxcaret-red']" :placeholder="$t('Forms.email')"
                            :name="$t('Forms.email')"
                            class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey" />

                        <p class="txt-error text-red text-xs italic">
                            {{ errors[0] }}
                        </p>
                    </ValidationProvider>

                    <ul class="emailsCommonList">
                        <li class="px-3 py-2 cursor-pointer" v-for="email in emailsCommonList" :key="email"
                            v-html="email" @click.prevent="setValuesToEmail(email)"></li>
                    </ul>

                    <p class="txt-error text-red text-xs italic" v-if="errorLogin.email">
                        {{ responseErrors.Email[0] }}
                    </p>
                </div>

                <div class="flex -mx-2">
                    <div class="w-1/2 mx-2">
                        <div class="w-full mb-2">
                            <ValidationProvider rules="required|uppercase|lowercase|containsNumber|specialChars|min:8"
                                v-slot="{ errors }" vid="confirmation">
                                <label class="font-bold" :for="$t('Forms.new_password')">
                                    {{ $t("Forms.new_password") }}</label>
                                <input type="password" :id="$t('Forms.new_password')" :name="$t('Forms.new_password')"
                                    v-model="formRegister.Password" :class="[errors.length && 'border-newxcaret-red']"
                                    class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey" />
                                <p class="txt-error text-red text-xs italic">
                                    {{ errors[0] }}
                                </p>
                            </ValidationProvider>
                        </div>

                        <div class="w-full mb-2">
                            <ValidationProvider rules="required|confirmed:confirmation" v-slot="{ errors }">
                                <label class="font-bold" :for="$t('Forms.confirmation_password')">
                                    {{ $t("Forms.confirmation_password") }}</label>
                                <input type="password" v-model="formRegister.ConfirmationPassword"
                                    :id="$t('Forms.confirmation_password')" :name="$t('Forms.confirmation_password')"
                                    :placeholder="$t('Forms.confirmation_password')"
                                    :class="[errors.length && 'border-newxcaret-red']"
                                    class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey" />
                                <p class="txt-error text-red text-xs italic">
                                    {{ errors[0] }}
                                </p>
                            </ValidationProvider>
                        </div>
                    </div>

                    <PasswordRules />
                </div>

                <!-- <div class="flex -mx-2">
                    <div class="w-1/2 mx-2 mb-2">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <label class="font-bold" :for="$t('Forms.birthdate')">
                                {{ $t("Forms.birthdate") }}
                            </label>
                            <input type="text" v-mask="'##/##/###'" v-model="formRegister.Birthdate"
                                placeholder="20/09/1999" :name="$t('Forms.birthdate')"
                                :class="[errors.length && 'border-newxcaret-red']"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey" />
                            <p class="txt-error text-red text-xs italic">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>

                    <div class="w-1/2 mx-2 mb-2">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <label class="font-bold" :for="$t('Forms.country')">
                                {{ $t("Forms.country") }}
                            </label>
                            <input type="text" v-model="formRegister.Locale" :placeholder="$t('Forms.country')"
                                :name="$t('Forms.country')" :class="[errors.length && 'border-newxcaret-red']"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey" />
                            <p class="txt-error text-red text-xs italic">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>
                </div> -->

                <!-- Phone -->
                <!-- <div class="flex -mx-2">
                    <div class="w-1/2 mx-2 mb-2">
                        <ValidationProvider rules="required|numeric|max:16" v-slot="{ errors }">
                            
                            <label class="font-bold" :for="$t('Forms.phone')">
                                {{ $t("Forms.phone") }}
                            </label>
                            <input type="text" v-model="formRegister.Phone" :placeholder="$t('Forms.phone')"
                                :name="$t('Forms.phone')" :class="[errors.length && 'border-newxcaret-red']"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey" />
                            <p class="txt-error text-red text-xs italic">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>
                </div> -->

                <br /><br />

                <p class="txt-error text-red text-xs italic" v-if="msgApi.error">
                    {{ msgApi.message }}
                </p>

                <p class="text-green-xcaret text-xs italic" v-if="msgApi.success">
                    {{ msgApi.message }}
                </p>
                <div class="flex flex-col md:flex-row mt-4">
                    <button type="submit"
                        class="flex items-center justify-center w-full mt-4 md:mx-2 md:my-auto p-2 bg-yellow-photo rounded-full text-sm font-semibold">
                        {{ $t("Forms.create_account") }}
                    </button>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import "@validators/index";
import methodUser from "@mixins/methodUser";

// Models

// Mixins
import Users from "@mixins/Users";
import Helper from "@mixins/helper";

import SearchPackage from "@components/photo/searchPackageComponent";
import registerData from "@logic/profile/register";

import Multiselect from 'vue-multiselect';
import PasswordRules from "@components/partials/PasswordRules.vue";

export default {
    props: [],
    mixins: [methodUser, Users, Helper],
    components: {
        SearchPackage,
        PasswordRules,
        Multiselect
    },
    data: () => ({
        loading: false,
        formRegister: {
            FirstName: "",
            LastName: "",
            Email: "",
            Password: "",
            ConfirmationPassword: "",
            Birthdate: "",
            Locale: "",
            Phone: ""
        }
    }),
    watch: {
        activeForm: function () {
            this.errorLogin.statusApiMessage = false;
            this.msgApi.success = false;
            this.msgApi.error = false;
            this.disableAllInputs();
        },
        'formRegister.Email': function (val) {
            this.setValueWatchEmail(val);
        }
    },
    computed: {
        // Acceder al state de 'auth' module
        ...mapState('auth', ['modalAuth', 'user']),

        // Usar getters de 'auth' module
        ...mapGetters('auth', ['getModalAuth', 'getUser', 'getEmailsCommon']),
    },
    methods: {
        // Usar acciones de 'auth' module
        ...mapActions('auth', ['setModalAuth', 'setUser']),
        /**
         * Método para registrar un nuevo usuario
         * @returns {Promise<void>}
         */
        async register() {
            try {
                this.$store.dispatch("setLoading", true);
                // POST request using axios
                let response = await registerData.create(this.formRegister);
                this.errorLogin.statusApiMessage = false;

                //Usuario creado pero no activado
                if (response?.data?.userData?.emailVerified === false) {
                    this.$store.dispatch("setModalLogin", true);
                    this.setUser({ email: response.data.userData.email });
                    this.setModalAuth(3);
                    Vue.$toast.open({
                        message: response?.data?.MESSAGE,
                        type: "warning",
                    });

                    return;
                }

                //Usuario no autenticado
                if (response?.data?.SUCCESS == "false" && response?.data?.MESSAGE) {
                    this.msgApi.error = true;
                    this.msgApi.message = response.data.MESSAGE;
                    Vue.$toast.open({
                        message: response?.data?.MESSAGE,
                        type: "error",
                    });

                    return;
                }

                if (response?.data?.SUCCESS == "true") {
                    Vue.$toast.open({
                        message: response.data.MESSAGE,
                        type: "success",
                    });
                    this.setUser({
                        firstName: this.formRegister.FirstName,
                        lastName: this.formRegister.LastName,
                        email: this.formRegister.Email
                    });
                    this.setModalAuth(3);

                    return;
                }
            } catch (error) {
                Vue.$toast.open({
                    message: $t("Forms.try_catch_api"),
                    type: "error",
                });

            } finally {
                //se settea el loadign para desaactivarlo
                this.$store.dispatch("setLoading", false);
            }
        },
        /**
         * Método para validar los campos del formulario de registro
         * @param {email} email
         */
        setValuesToEmail(email = "") {
            if (email != "") {
                this.formRegister.Email = email;
            }
            this.emailsCommonList = [];
            this.flatSelectEmail = true;
        }
    },
    mounted() {},
};
</script>
